<template lang="html">
  <a
    ref="button"
    v-tracking-context="{id: jobId}"
    :href="href"
    target="blank"
    :class="classes"
    @click="openModal"
  >
    <button
      :disabled="disabled"
      class="button button--primary button--bold"
      :class="buttonClasses"
    >{{ 'client.apply_button' | t }}</button>
  </a>
</template>

<script>
import ApplyModalContent from './apply_modal_content'
import EmailApplicationModal from './email_application_modal'

export default {
  props: {
    classes: {
      type: String,
      default: ''
    },
    buttonClasses: {
      type: String,
      default: ''
    },
    applyEmail: {
      type: String,
      default: null
    },
    applyUrl: {
      type: String,
      default: null
    },
    jobId: {
      type: String,
      default: null
    },
    jobTitle: {
      type: String,
      default: null
    },
    jobEmployer: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    href () {
      if (this.applyUrl) {
        return this.applyUrl
      } else if (this.applyEmail) {
        return '#job_application_form'
      } else {
        return '#apply_modal'
      }
    }
  },
  methods: {
    openModal ($event) {
      EventBus.trigger('tracking:manualEventTrack', { action_type: 'apply', $elem: $(this.$refs.button) })
      if (this.applyUrl) {
        // Do nothing and let the browser handle the link
        return null
      }

      $event.preventDefault()

      if (this.applyEmail) {
        this.$store.commit('modalOpen', { component: EmailApplicationModal, props: this.$props })
      } else {
        this.$store.commit('modalOpen', { component: ApplyModalContent })
      }
    }
  }
}
</script>
